<template>
  <div class="mt-6">
    <quill-editor
      v-model="mailMessage"
      :options="editorOption"
      class="quill-h200px"
    />
  </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
export default {
  data() {
    return {
      mailMessage: "",
      editorOption: {
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              "strike",
              "link",
              "blockquote",
              "code-block"
            ],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ font: [] }]
          ]
        },
        placeholder: "Message"
      }
    };
  },
  components: {
    quillEditor
  },
  methods: {
    clearFields() {
      this.$nextTick(() => {
        this.mailMessage = "";
      });
    },
    sendMail() {
      this.clearFields();
    }
  }
};
</script>
<style>
.quill-h200px > .ql-container {
  height: 200px;
}
</style>
